import { SVGProps, Ref, forwardRef } from 'react';

export const BubbleRoundOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.8 19.406v-4.157c-2.884-.11-5.942-.186-8.474-1.747C2.754 12.532 1.8 11.142 1.8 9c0-2.252 1.058-3.695 2.824-4.677C6.498 3.283 9.152 2.8 12 2.8s5.502.482 7.376 1.523C21.142 5.305 22.2 6.748 22.2 9c0 2.147-1.619 4.324-4.334 6.621-1.61 1.363-3.346 2.566-5.066 3.785M11 23v-6.019C5.351 16.765 0 14.666 0 9c0-6 6-8 12-8s12 2 12 8c0 6.052-8.922 10.602-13 14M7 8.1v1.8h10V8.1z"
                fill="currentColor"
            />
        </g>
    </svg>
));
BubbleRoundOutlinedSize24Glyph.displayName = 'BubbleRoundOutlinedSize24Glyph';
